import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
//import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { Router, NavigationExtras } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddmodifierComponent } from './addmodifier/addmodifier.component';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';
@Component({
  selector: 'app-modifier',
  templateUrl: './modifier.component.html',
  styleUrls: ['./modifier.component.css']
})
export class ModifierComponent implements OnInit, AfterViewInit, OnDestroy {

  modifierColl: any = [];
  modifiertypeColl: any = [];
  pricetypeColl: any = [];

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Modifier";

  isaddpricetype:boolean=false;

  searchtxt: any = "";
  columnDefs = [
    { headerName: 'Modifier', field: 'modifiername' },
    { headerName: 'Modifier Type', field: 'modifiertypename' },
    { headerName: 'Tax', field: 'taxname' },
    { headerName: 'Modifier Price', field: 'modifierprice' },
    { headerName: 'Status', field: 'activestatus' ,type:'activestatus'},    
  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
  };

  filtermodifiertype: number = null;

  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService) { this.fnServiceChanges(); }

  //User Check
  //User Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.fnCheckPrivilage();
          if (this.isview) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.fnCheckPrivilage();
          if (this.isview) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnOnInitForm() {
    this.fngetPricetype() 
    this.fngetModifier();
    this.fngetModifiertype();
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {

  }
  fngetPricetype() {
    var data = {
      'pricetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      

    }
    this.appService.getPricetype(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.pricetypeColl = res.json().result;
            this.fnSetTable();
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnSetTable() {
   if(this.isaddpricetype){
    return
   }
    for (let row of this.pricetypeColl) {
    
        if (row.pricetag === "SP1") {
          this.columnDefs.push({ headerName:row.pricetypename, field: 'sp1' })
        }
        else if (row.pricetag === "SP2") {
          this.columnDefs.push({ headerName:row.pricetypename, field: 'sp2' })
        }
        else if (row.pricetag === "SP3") {
          this.columnDefs.push({ headerName:row.pricetypename, field: 'sp3' })
        }
        else if (row.pricetag === "SP4") {
          this.columnDefs.push({ headerName:row.pricetypename, field: 'sp4' })
        }
        else if (row.pricetag === "SP5") {
          this.columnDefs.push({ headerName:row.pricetypename, field: 'sp5' })
        }
        else if (row.pricetag === "SP6") {
          this.columnDefs.push({ headerName:row.pricetypename, field: 'sp6' })
        }
        else if (row.pricetag === "SP7") {
          this.columnDefs.push({ headerName:row.pricetypename, field: 'sp7' })
        }
        else if (row.pricetag === "SP8") {
          this.columnDefs.push({ headerName:row.pricetypename, field: 'sp8' })
        }
        else if (row.pricetag === "SP9") {
          this.columnDefs.push({ headerName:row.pricetypename, field: 'sp9' })
        }
        else if (row.pricetag === "SP10") {
          this.columnDefs.push({ headerName:row.pricetypename, field: 'sp10' })
        }
       
        this.isaddpricetype=true
    }
  }
  fngetModifiertype() {

    var data = {
      'modifiertypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getModifiertype(data)
      .subscribe(
        (res) => {


          if (res.json().status == 200) {
            this.modifiertypeColl = res.json().result;

          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }


  fngetModifier() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'modifierid': 0,
      'modifiertypeid': this.filtermodifiertype,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getModifier(data)
      .subscribe(
        (res) => {

          this.fnHideProgress();
          if (res.json().status == 200) {
            this.modifierColl = res.json().result;
            this.fnSetDataTable();
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }

  fnAddModifier() {
    try {
      const modalRef = this.productFindService.open(AddmodifierComponent, { size: <any>'l', backdrop: 'static' });


      modalRef.componentInstance.ngOnInit();

      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetModifier();

      });


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnEditModifier(pBO) {

    try {

      var deptid = pBO.modifierid
      if (!this.isedit) {
        return;
      }
      const modalRef = this.productFindService.open(AddmodifierComponent, { size: <any>'l', backdrop: 'static' });
      modalRef.componentInstance.modifierid = deptid;

      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetModifier();

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  public fnDeleteConfirm(pBO) {
    try {
      var deptid = pBO.modifierid
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete Modifier?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteModifier(deptid)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteModifier(deptid) {
    var data = {
      'modifierid': deptid,
    }
    this.appService.fnDeleteModifier(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.toastr.success('', " The Modifier has been deleted successfully.");

            this.fnInsertActivityLog('DELETE', deptid, this.fnGetDescription(deptid));

            this.fngetModifier();
          } else {
            this.toastr.error('', res.json().err_field);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }







  private fnSetDataTable() {

  }


  fnPrintData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnExportData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnActionExportClick()  {
    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.modifierColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  }

  fnGetDescription(id) {
    const index = this.modifierColl.findIndex(sku => sku.modifierid === id);

    if (index) {
      return this.modifierColl[index].productgroup;
    }
    else {
      return "";
    }

  }

  public fnSearchDatatable(value) {


  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }




}
